import { KeycloakAdminService } from '@nv/auth'
import { nxConfig } from '@nv/utils'
import axios from 'axios'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
const VERIFY_COOKIE = 'verifyTokenAdmin'

export const AdminAxiosInstance = axios.create({
  withCredentials: true,
  headers: {},
  baseURL: `${nxConfig.PUBLIC_URL}/admin`,
})

// attach access token
AdminAxiosInstance.interceptors.request.use(
  async (config) => {
    const accessToken = KeycloakAdminService.getToken()
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

// flattens the layer of nested introduced by axios
// the responses look like { data, error }, but axios nests the whole response under 'data'
AdminAxiosInstance.interceptors.response.use(
  (res: any) => {
    res = res.data
    if (res?.accessToken) {
      cookies.set(VERIFY_COOKIE, res.accessToken)
    }
    if (typeof res?.link === 'string' && res.link.includes('login-actions')) {
      window.location.replace(res.link)
      cookies.remove(VERIFY_COOKIE)
    }
    return res
  },
  async (err) => {
    const error = {
      ...err.response?.data?.error,
      ...err,
    }
    return Promise.reject(error)
  },
)

export default AdminAxiosInstance
